<template>
  <div class="s-summary">
    <div class="title-text-style">Store Summary</div>
    <div class="select-option block">
      <b-loading
        v-model="isLoading"
        :is-full-page="true"
      >
       <font-awesome-icon
        icon="fa-solid fa-sync" spin
        size="2x">
      </font-awesome-icon>
      <div style="padding-left:10px;"> Loading Data </div>
      </b-loading>
      <div class="columns is-vcentered is-multiline is-centered">
        <!-- <div class="column">
          <b-field label="Select Branch">
            <b-select
              placeholder="select Branch"
              v-model="selectedBranch"
            >
              <option
                v-for="option in branchs"
                :value="option.name"
                :key="option.name"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div> -->
        <div class="columns column">
          <b-field
            position="is-centered"
            class="column is-half"
            label="Select Timeframe"
          >
            <b-radio-button
              v-model="timeframe"
              native-value="day"
            >
              Day
            </b-radio-button>
            <b-radio-button
              v-model="timeframe"
              native-value="week"
            >
              Week
            </b-radio-button>
            <b-radio-button
              v-model="timeframe"
              native-value="month"
            >
              Month
            </b-radio-button>
          </b-field>
          <section class="column is-half">
            <b-field label="Custom Timeframe">
              <b-datepicker
                placeholder="Click to select..."
                v-model="dates"
                range
                icon="calendar-today"
                trap-focus
                :locale="undefined"
                :max-date="maxDate"
                @input="bySelectDates"
              >
              </b-datepicker>
            </b-field>
          </section>
        </div>
      </div>
    </div>
    <div
      v-if="!nodata"
      class="summary-grid"
    >
      <bar-chart
        title='bar-s'
        :chartData="computedBranchData"
        class="wewchart"
      />
      <table-info
        :tableData="computedBranchData"
        class="table-info"
      />
    </div>
    <div
      v-else
      class="summary-grid"
    >
      <database-not-found class="wewchart" />
      <!-- <database-not-found class="table-info" /> -->
    </div>
  </div>
</template>

<script>
import branchs from '../setting/branchs'
// import PieChart from '../components/PieChart.vue'
import TableInfo from '../components/TableInfo.vue'
import DatabaseNotFound from '../components/etc/DatabaseNotFound.vue'
import dayjs from 'dayjs'
import BarChart from '../components/BarChart.vue'
export default {
  name: 'StoreSummary',
  // components: { PieChart, TableInfo, DatabaseNotFound, BarChart },
  components: { TableInfo, BarChart, DatabaseNotFound },
  data () {
    return {
      isLoading: false,
      branchs: branchs,
      maxDate: new Date(),
      timeframe: 'day',
      dates: [],
      selectedBranch: 'Bangna',
      dayInfo: []
    }
  },
  mounted () {
    console.log('This mounted')
    this.$store.commit('summary/clearStoreDetail')
    this.getStoreData(this.timeframeSelection)
  },
  watch: {
    timeframe: {
      async handler (val) {
        if (val) {
          this.isLoading = true
          console.log('What Select', val)
          this.dates = []
          this.$store.commit('summary/clearStoreDetail')
          await this.getStoreData(this.timeframeSelection)
          this.isLoading = false
        }
      }
    }
  },
  computed: {
    nodata () {
      return this.$store.getters['summary/haveNoData']
    },
    timeframeSelection () {
      let dayInfo = []
      if (this.timeframe) {
        switch (this.timeframe) {
          case 'day':
            dayInfo = this.getDayjsFormatByTimeframe(0)
            break
          case 'week':
            dayInfo = this.getDayjsFormatByTimeframe(6)
            break
          case 'month':
            dayInfo = this.getDayjsFormatByTimeframe(30)
            break
          default:
            dayInfo = this.getDayjsFormatByTimeframe(0)
            break
        }
      }
      if (this.dates.length) {
        const date1 = dayjs(this.dates[1]).add(dayjs().get('hour'), 'hour')
        const date2 = dayjs(this.dates[0]).add(dayjs().get('hour'), 'hour')
        const dateDiff = date1.diff(date2, 'day')
        dayInfo = [date1, dateDiff]
      }
      console.log('this.dates', this.dates)
      console.log('dateInfo', dayInfo, 'timeframe', this.timeframe)
      return dayInfo
    },
    storeData () {
      return this.$store.getters['summary/storeData']
    },
    branchData () {
      return this.$store.getters['summary/listBranch']
    },
    computedBranchData () {
      const dimensions = ['branch', 'on-time', 'late', 'percentOn']
      const source = []
      const sourceDer = []
      for (const [name, value] of Object.entries(this.branchData)) {
        const delivered = value.onTime + value.late
        const percentOn = (value.onTime / (value.onTime + value.late)) * 100
        source.push([name, value.onTime, value.late, percentOn])
        sourceDer.push([
          name,
          delivered,
          value.onTime,
          value.late,
          percentOn.toFixed(2)
        ])
      }
      return { dimensions, source, sourceDer }
    },
    getDayjsFormatByTimeframe () {
      return (days) => {
        const date1 = dayjs(new Date())
        const date2 = dayjs(new Date()).subtract(days, 'day')
        const dateDiff = date1.diff(date2, 'day')
        return [date1, dateDiff]
      }
    }
  },
  methods: {
    async getStoreData (timeframe) {
      await this.$store.dispatch('summary/getStoreDetail', {
        timeframe: timeframe
      })
    },
    async bySelectDates () {
      this.isLoading = true
      this.timeframe = null
      // console.log('ARE YOU ????')
      this.$store.commit('summary/clearStoreDetail')
      await this.getStoreData(this.timeframeSelection)
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.s-summary {
  /* margin-bottom: 50px;
  padding: 25px; */
}
.title-text-style {
  text-align: left;
  margin-top: 10px;
  margin-left: 0px;
  margin-bottom: 10px;
  font-size: 30px;
  color: #1e4b84;
}
.summary-grid {
  display: grid;
  grid-template-columns: 60% auto;
  grid-template-areas:
    'select-option select-option'
    /* 'wewchart table-info'
    'wewchart table-info'; */
    'wewchart wewchart'
    'wewchart wewchart'
    'table-info table-info';
  column-gap: 20px;
  row-gap: 20px;
}
.wewchart {
  grid-area: wewchart;
  min-height: 700px;
}
.table-info {
  grid-area: table-info;
  min-height: 190px;
}
.select-option {
  grid-area: select-option;
  min-height: 100px;
}
/* .notifications {
    grid-area: notifications;
    min-height: 190px;
}
.subscription {
    grid-area: subscription;
    min-height: 190px;
} */
</style>
